import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GLPaymentDto } from '../../dtos/gl-payment-dto.model';
import { OrderService } from '../../services/order.service';
import { SwalAlert } from '../../helpers/alert';
import { ModeService } from '../../services/mode.service';
import { Mode } from 'src/app/enums/mode.enum';

@Component({
  selector: 'app-gl-dialog',
  templateUrl: './gl-dialog.component.html',
  styleUrls: ['./gl-dialog.component.css']
})
export class GlDialogComponent implements OnInit {
  @Input() show = false;
  @Input() elementId = 'glStringOE';
  @Output() showChange = new EventEmitter<boolean>();
  @Output() onSave = new EventEmitter<{ count: number; firstGLString: string | null }>();

  glEntries: Array<{
    id: number;
    glString: string;
    Date: Date;
    ModifiedUtcDate?: Date;
    invoiceId?: number | null;
    amount: number;
    tax: number;
    total: number;
    percent?: number;
    shipped: boolean;
    blurred: boolean;
    lockedByShipment?: boolean;
    glStringError?: boolean;
  }> = [];
  orderIsShipped =false

  amount = 0;
  showInvoiceColumn = false;
  initialGLFromMain = '';
  swalAlert = new SwalAlert();
  private readonly useSubtotalBase = true;
  constructor(public orderService: OrderService, private modeService: ModeService) {}
errorMessage = '';  
showInlineAlert = false;
showReadjustPrompt = false;


  ngOnInit(): void {
    this.amount = this.sumOpenExtendedPrice();
  }

  openDialog(): void {
    const billToId = this.orderService.orderDto?.billToDto?.id;
    if (billToId === 0 || billToId === null || billToId === undefined) {
      this.swalAlert.alert('Account information details should be populated before entering GL String');
      return;
    }

    this.showInvoiceColumn = !!(this.orderService.orderDto.invoiceDtos && this.orderService.orderDto.invoiceDtos.length > 0);

   
    if (this.orderService.orderDto.glPayments && this.orderService.orderDto.glPayments.length > 0) {
      const today = new Date();
      this.glEntries = this.orderService.orderDto.glPayments.map((g: GLPaymentDto) => ({
        id: g.Id || 0,
        glString: g.GLString || '',
        Date: g.CreatedUtcDate ? new Date(g.CreatedUtcDate) : today,
        invoiceId: g.InvoiceId ?? null,
        amount: Number(g.glAmount) || 0,
        tax: Number(g.Tax) || 0,
        total: (Number(g.glAmount) || 0) + (Number(g.Tax) || 0),
        percent: g.GLPercent ?? 0,
        shipped: false,
        readOnly: false, 
        blurred: false
      }));
      this.loadFromDto();
    }
   
    
    else {
      const today = new Date();

      const amount = this.round2(this.sumOpenExtendedPrice());
      const tax = this.round2(this.sumOpenTax());
      const total = this.round2(amount + tax);

      
      const defaultGL = (this.orderService.orderDto as any).glPayment ?? '';

      this.glEntries = [{
        id: 0,
        glString: defaultGL,     
        Date: today,            
        invoiceId: null,
        amount,                 
        tax,                     
        total,                  
        percent: amount > 0 ? 100 : 0,
        shipped: false,
        blurred: false
      }];
    }

    this.lockShippedRows();
    this.applyShipmentLocking();
    this.show = true;
    this.showChange.emit(this.show);

    // After loading entries, check if saved GL amounts differ from the current open order total
    if (this.orderService.orderDto.glPayments && this.orderService.orderDto.glPayments.length > 0 && this.editableRows().length > 0) {
    const openTotal = this.getOpenOrderTotal();
    const editableTotal = this.round2(this.editableRows().reduce((s, r) => s + (Number(r.amount) + (Number(r.tax) || 0)), 0));
    if (Math.abs(openTotal - editableTotal) > 0.01) {
      this.showReadjustPrompt = true;
    }
  }
  }
  
  addGLRow(): void {
    const editable = this.editableRows();
    const usedAmount = this.round2(editable.reduce((sum, r) => sum + (Number(r.amount) || 0), 0));
    const usedTax = this.round2(editable.reduce((sum, r) => sum + (Number(r.tax) || 0), 0));
    const remainingAmount = this.round2(this.sumOpenExtendedPrice() - usedAmount);
    const remainingTax = this.round2(this.sumOpenTax() - usedTax);
    const remainingTotal = this.round2(remainingAmount + remainingTax);
    // const base = this.getOpenOrderTotal();
    const usedPercent = this.round2(editable.reduce((sum, r) => sum + (Number(r.percent) || 0), 0));
    const percent = this.round2(100 - usedPercent);
    // const percent = base > 0 ? this.round2((remainingAmount / base) * 100) : 0;

    this.glEntries.push({
      id: 0,
      glString: '',
      Date: new Date(),
      invoiceId: null,
      amount: remainingAmount,
      tax: remainingTax,
      total: remainingTotal,
      percent,
      shipped: false,
      blurred: false
    });
    this.applyShipmentLocking();
  }

 
deleteGLRow(index: number): void {
  if (index >= 0 && index < this.glEntries.length) {
    this.glEntries.splice(index, 1);
    
 if (this.glEntries.length === 0) {
  this.errorMessage = '';
  this.showInlineAlert = false;
  return;
}
    this.rebalancePercentsAfterChange();
     this.applyShipmentLocking();
    this.validateGLEntries();
  }
}


recalculate(index: number, source: 'amount' | 'tax' | 'percent' = 'amount'): void {
  const row = this.glEntries[index];
  const base = this.getOpenOrderTotal(); 

  if (source === 'percent') {
    const pct = Number(row.percent) || 0;
    const openExtended = this.sumOpenExtendedPrice();
    const openTax = this.sumOpenTax();
    row.amount = this.round2((pct / 100) * openExtended);
    row.tax    = this.round2((pct / 100) * openTax);
  } else if (source === 'amount') {
    row.percent = base > 0 ? this.round2(((Number(row.amount) || 0) / base) * 100) : 0;
  }

  const amt = this.asNumber(row.amount);
  const tax = this.asNumber(row.tax);
  row.total = this.round2(amt + tax);
  this.glEntries[index].ModifiedUtcDate= new Date();
}


onAmountChange(val: any, index: number): void {
  const row = this.glEntries[index];
  row.amount = this.toNumber(val);
  this.recalculate(index, 'amount');
}
onTaxChange(val: any, index: number): void {
  const row = this.glEntries[index];
  row.tax = this.toNumber(val);
  this.recalculate(index, 'tax');
}

onPercentChange(val: any, index: number): void {
  const row = this.glEntries[index];
  row.percent = this.toNumber(val);
  this.recalculate(index, 'percent');
}


  lockShippedRows(): void {
    this.glEntries.forEach(r => (r.blurred = !!r.shipped));
  }

  

  validateGLEntries(): boolean {
    const rowsToValidate = this.editableRows();
    if (rowsToValidate.length === 0) {
      this.errorMessage = '';
      this.showInlineAlert = false;
      return true;
    }
    const blankIndexes: number[] = [];
    this.glEntries.forEach((r, i) => {
      if (r.blurred) return;
      const s = (r.glString ?? '').toString().trim();
      if (!s) blankIndexes.push(i);
    });
  
    if (blankIndexes.length > 0) {
      const rows = blankIndexes.map(i => i + 1).join(', ');
      this.errorMessage = blankIndexes.length === 1
        ? `GL String is required (Row ${rows}).`
        : `GL String is required (Rows ${rows}).`;
  
      this.showInlineAlert = true;
      return false;
    }
  
    const sumAmounts = rowsToValidate.reduce((a, r) => a + (Number(r.amount) + (Number(r.tax) || 0)), 0);
    const openTotal = this.getOpenOrderTotal();
    const tolerance = 0.01;
  
    if (Math.abs(sumAmounts - openTotal) > tolerance) {
      this.errorMessage =
        `Sum of $ Amounts (${this.round2(sumAmounts)}) must equal the Open Order Total (${this.round2(openTotal)}).`;
      this.showInlineAlert = true;
      return false;
    }
  if (this.glEntries.some(r => !r.blurred && r.glStringError)) {
  this.errorMessage =
    "GL String does not meet Accounting requirements, please verify and enter again.";
  this.showInlineAlert = true;
  return false;
}  
    this.errorMessage = '';
    this.showInlineAlert = false;
    return true;
  
}


  
saveGLEntries(): void {

  if (this.glEntries.length === 0) {
    this.orderService.orderDto.glPayments = [];
    this.orderService.orderDto.glPayment = '';
    this.show = false;
    this.showChange.emit(this.show);
    this.onSave.emit({ count: 0, firstGLString: null });
    return;
  }

  if (!this.validateGLEntries()) return;

  this.orderService.orderDto.glPayments =
    this.glEntries.map(r => ({
      Id: r.id ?? 0,
      CreatedUtcDate: this.toIso(r.Date),
      ModifiedUtcDate: this.toIso(r.ModifiedUtcDate),
      OrderId: this.orderService.orderDto.id,
      InvoiceId: r.invoiceId ?? null,
      GLString: r.glString,
      glAmount: Number(r.amount) || 0,
      GLPercent: r.percent ?? null,
      Tax: Number(r.tax) || 0
    }));

  const count = this.orderService.orderDto.glPayments.length;

  this.orderService.orderDto.glPayment =
    count === 1
      ? this.orderService.orderDto.glPayments[0]?.GLString ?? ''
      : count > 1
        ? 'Multiple'
        : '';

  this.show = false;
  this.showChange.emit(this.show);
  this.onSave.emit({
    count,
    firstGLString: count === 1
      ? this.orderService.orderDto.glPayments[0]?.GLString ?? ''
      : null
  });
}

  cancelGLEntries(): void {
    this.glEntries = [];
    this.show = false;
    this.showChange.emit(this.show);
  }

  getOrderTotal(): number {
    const details = this.getOrderDetails();
    const total = details
      .filter((item: any) => item.orderDetailStatus !== 'V')
      .reduce((sum: number, item: any) =>
        sum + (Number(item.extendedPrice) || 0) + (Number(item.taxAmount) || 0), 0);
    return this.round2(total);
  }

  getOpenOrderTotal(): number {
    const details = this.getOrderDetails();
    const total = details
      .filter((item: any) => item.orderDetailStatus?.trim?.() === '')
      .reduce((sum: number, item: any) =>
        sum + (Number(item.extendedPrice) || 0) + (Number(item.taxAmount) || 0), 0);
    return this.round2(total);
  }

  private getOrderDetails(): any[] {
    const dto = this.orderService.orderDto as any;
    const arr = dto.orderDetails ?? dto.orderDetailDtos ?? [];
    return Array.isArray(arr) ? arr : [];
  }

  hasNoRemainingAmount(): boolean {
    const editableUsed = this.round2(
    this.editableRows().reduce((sum, r) => sum + (Number(r.amount) || 0), 0)
    );
    const remaining = this.round2(this.sumOpenExtendedPrice() - editableUsed);
    return remaining <= 0;
  }

  private sumOpenExtendedPrice(): number {
    return this.getOrderDetails()
      .filter(i => i.orderDetailStatus === ' ')
      .reduce((s, i) => s + (Number(i.extendedPrice) || 0), 0);
  }

  
  private sumOpenTax(): number {
    return this.getOrderDetails()
      .filter(i => i.orderDetailStatus === ' ')
      .reduce((s, i) => s + (Number(i.taxAmount) || 0), 0);
  }

  

  private round2(n: number): number {
    return Math.round((Number(n) || 0) * 100) / 100;
  }
  private toNumber(val: any): number {
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  }

  
  toDateInputValue(d: Date): string {
    const dd = d instanceof Date ? d : new Date(d);
    const y = dd.getFullYear();
    const m = String(dd.getMonth() + 1).padStart(2, '0');
    const da = String(dd.getDate()).padStart(2, '0');
    return `${y}-${m}-${da}`;
  }
  


private getOrderSubtotalBase(): number {
  const details = this.getOrderDetails();
  const subtotal = details
    .filter((item: any) => item.orderDetailStatus !== 'V')
    .reduce((sum: number, item: any) => sum + (Number(item.extendedPrice) || 0), 0);
  return this.round2(subtotal);
}


private getOrderTotalBase(): number {
  return this.getOrderTotal();
}


private getPercentBase(): number {
  return this.useSubtotalBase ? this.getOrderSubtotalBase() : this.getOrderTotalBase();
}

onInlineAlertOk(): void {
  this.showInlineAlert = false;  
}

/** Redistribute each editable row's amount/tax proportionally by its saved percent against the new open order total */
rebalanceByPercent(): void {
  this.showReadjustPrompt = false;
  const newTotal = this.getOpenOrderTotal();
  const newTax   = this.round2(this.sumOpenTax());
  const editableRows = this.glEntries.filter(r => !r.blurred);
  if (editableRows.length === 0) return;

  const totalPercent = this.round2(editableRows.reduce((s, r) => s + (Number(r.percent) || 0), 0));
  const base = totalPercent > 0 ? totalPercent : 100;

  let usedAmount = 0;
  let usedTax    = 0;
  editableRows.forEach((row, idx) => {
    const isLast = idx === editableRows.length - 1;
    const pct    = Number(row.percent) || 0;
    const amt    = isLast ? this.round2(newTotal - usedAmount) : this.round2((pct / base) * newTotal);
    const tx     = isLast ? this.round2(newTax   - usedTax)   : this.round2((pct / base) * newTax);
    row.amount = this.round2(amt - tx);
    row.tax    = this.round2(tx);
    row.total  = this.round2(amt);
    if (!isLast) { usedAmount = this.round2(usedAmount + amt); usedTax = this.round2(usedTax + tx); }
  });
}

dismissReadjustPrompt(): void {
  this.showReadjustPrompt = false;
}

public loadFromDto(): void {
  const dto = this.orderService.orderDto;
  const today = new Date();
 
  this.showInvoiceColumn = !!(dto?.invoiceDtos && dto.invoiceDtos.length > 0);
 
  const payments = dto?.glPayments ?? [];
 
  if (payments.length > 0) {
    this.glEntries = payments.map((g: any) => {
      const id = g.id ?? g.Id ?? 0;
      const glString = g.glString ?? g.GLString ?? '';
      const createdUtc = g.createdUtcDate ?? g.CreatedUtcDate ?? null;
      const ModifiedUtcDate =g.modifiedUtcDate ?? g.ModifiedUtcDate ?? null;
      const invoiceId = g.invoiceId ?? g.InvoiceId ?? null;
      const glAmount = g.glAmount ?? g.GLAmount ?? 0;
      const taxVal = g.tax ?? g.Tax ?? 0;
      const glPercent = g.glPercent ?? g.GLPercent ?? 0;
      const amount = Number(glAmount) || 0;
      const tax = Number(taxVal) || 0;
 
      return {
        id,
        glString,
        Date: createdUtc ? new Date(createdUtc) : today, 
        ModifiedUtcDate: g.ModifiedUtcDate ? new Date(g.ModifiedUtcDate) : undefined,
        invoiceId: invoiceId ?? null,                    
        amount,
        tax,
        total: amount + tax,
        percent: Number(glPercent) || 0,                 
        shipped: false,
        blurred: false
      };
    });
  } else {
    this.glEntries = []; 
  }
 
  this.lockShippedRows?.();
  this.applyShipmentLocking();
}

private asNumber(n: any): number {
  const v = Number(n);
  return isFinite(v) ? v : 0;
}


totalAmount(): number {
  const sum = this.glEntries.reduce((acc, r) => acc + this.asNumber(r.amount), 0);
  return this.round2(sum);
}

totalPercent(): number {
  const sum = this.glEntries.reduce((acc, r) => acc + this.asNumber(r.percent), 0);
  return this.round2(sum);
}  

totalTax(): number {
  const sum = this.glEntries.reduce((acc, r) => acc + this.asNumber(r.tax), 0);
  return this.round2(sum);
}

totalOfTotals(): number {
 const sum = this.glEntries.reduce((acc, r) => acc + this.asNumber(r.total), 0);
  return this.round2(sum);
}

private computePercentFromAmount(amount: number, base: number): number {
  if (!isFinite(base) || base <= 0) return 0;
  return this.round2((this.asNumber(amount) / base) * 100);
}


private computeAmountFromPercent(percent: number, base: number): number {
  return this.round2((this.asNumber(percent) / 100) * this.asNumber(base));
}

private rebalancePercentsAfterChange(): void {
  const base = this.getOpenOrderTotal();
  const editable = this.glEntries
    .map((r, idx) => ({ r, idx }))
    .filter(x => !x.r.blurred);

  const n = editable.length;
  if (n === 0) return;
  if (n === 1) {
    const row = editable[0].r;
    row.percent = 100;
    row.amount  = this.computeAmountFromPercent(row.percent, base);
    row.total   = this.round2(this.asNumber(row.amount) + this.asNumber(row.tax));
    return;
  }
  let percents = editable.map(x => this.computePercentFromAmount(x.r.amount, base));

  const sumP = this.round2(percents.reduce((a, b) => a + this.asNumber(b), 0));
  if (sumP === 0) {
    const even = this.round2(100 / n);
    percents = editable.map(() => even);
  }
  const fixedSum = this.round2(percents.reduce((a, b) => a + this.asNumber(b), 0));
  const drift = this.round2(100 - fixedSum);
  percents[percents.length - 1] = this.round2(this.asNumber(percents[percents.length - 1]) + drift);
  editable.forEach((x, i) => {
    const row = x.r;
    row.percent = this.asNumber(percents[i]);
    row.amount  = this.computeAmountFromPercent(row.percent, base);
    row.total   = this.round2(this.asNumber(row.amount) + this.asNumber(row.tax));
  });
}

private parseSqlDateTime(raw: any): Date | null {
  if (!raw) return null;
  if (raw instanceof Date && isFinite(raw.getTime())) return raw;

  if (typeof raw === 'string') {
    const s = raw.trim();
    const normalized = s.includes('T') ? s : s.replace(' ', 'T');
    const d = new Date(normalized);
    return isFinite(d.getTime()) ? d : null;
  }

  const d = new Date(raw);
  return isFinite(d.getTime()) ? d : null;
}

private getLatestShipDateTimeFromOrderDetails(): Date | null {
  const details = this.getOrderDetails();
  if (!Array.isArray(details) || details.length === 0) return null;

  let latestMs = -Infinity;
  let latest: Date | null = null;

  for (const d of details) {
    const shipDT = this.parseSqlDateTime(d?.ShipDate ?? d?.shipDate ?? d?.shipdate);
    if (!shipDT) continue;
    const ms = shipDT.getTime();
    if (ms > latestMs) {
      latestMs = ms;
      latest = shipDT;
    }
  }

  return latest;
}


applyShipmentLocking(): void {
  const latestShipDate = this.getLatestShipDateTimeFromOrderDetails();
  const openTotal = this.getOpenOrderTotal();
  this.orderIsShipped = this.round2(openTotal) <= 0;

  this.glEntries.forEach(r => {
    const createdDate = r.Date instanceof Date ? r.Date : new Date(r.Date);
    const createdMs = createdDate.getTime();
    const lockedByShipment =
      !!latestShipDate && isFinite(createdMs) && createdMs < latestShipDate.getTime();

    r.lockedByShipment = lockedByShipment;
    const isExistingRow = r.id > 0;
    r.blurred = (isExistingRow && this.orderIsShipped) || lockedByShipment || !!r.shipped;
  });
}

private editableRows() {
  return (this.glEntries || []).filter(r => !r.blurred);
}


private toIso(d?: Date): string {
  return d instanceof Date && isFinite(d.getTime())
    ? d.toISOString()
    : new Date().toISOString();
}



onChangeGLString(val: string, index: number): void {
  const row = this.glEntries[index];

  const cleaned = (val || '').replace(/\s+/g, '').toUpperCase();

  let result = '';
  let pos = 0;  

  for (let i = 0; i < cleaned.length && pos < 24; i++) {
    const char = cleaned[i];

    // Section 1 (0–4) → digits only
    if (pos < 5) {
      if (!/\d/.test(char)) continue;
    }
    // Section 2 (5–9) → digits only
    else if (pos < 10) {
      if (!/\d/.test(char)) continue;
    }
    // Section 3 (10–17) → alphanumeric
    else if (pos < 18) {
      if (!/[A-Z0-9]/.test(char)) continue;
    }
    // Section 4 (18–23) → digits only
    else {
      if (!/\d/.test(char)) continue;
    }

    result += char;
    pos++; 
  }

  const s1 = result.substring(0, 5);
  const s2 = result.substring(5, 10);
  const s3 = result.substring(10, 18);
  const s4 = result.substring(18, 24);

  const formatted = [s1, s2, s3, s4].filter(Boolean).join(' ');

  row.glString = formatted;

  const isValid =
  /^\d{5}$/.test(s1) &&
  /^\d{5}$/.test(s2) &&
  /^(?=.*[A-Z])[A-Z0-9]{8}$/.test(s3) && 
  /^\d{6}$/.test(s4);

  row.glStringError = !isValid;

  if (!row.glStringError) {
    row.ModifiedUtcDate = new Date();
  }
}


allowOnlyValidInput(event: KeyboardEvent, rowIndex: number) {
  const char = event.key;
  const row = this.glEntries[rowIndex];

  if (char === 'Backspace' || char === 'Tab') return;

  // Allow only alphanumeric keys
  if (!/^[a-zA-Z0-9]$/.test(char)) {
    event.preventDefault();
    return;
  }

   const cleanedLength = (row.glString || '').replace(/\s+/g, '').length;
  if (cleanedLength >= 18 && !/\d/.test(char)) {
    event.preventDefault();
  }
}
hasGLStringErrors(): boolean {
  return this.glEntries.some(r => !r.blurred && r.glStringError);
}

}